import React from "react";
import ReactDOM from "react-dom";
import * as Sentry from "@sentry/browser";
import "bootstrap/dist/css/bootstrap.css";
import "@veriff/genoma/lib/base.css";
import { MemoryRouter, Route, Switch } from "react-router-dom";
import UploadPage from "./UploadPage/UploadPage";
import IntroPage from "./IntroPage/IntroPage";

import * as serviceWorker from "./serviceWorker";

// TODO: check if those are used/necessary?
import "./index.css";

if (window.INIT_DATA && window.INIT_DATA.SENTRY_DSN) {
    Sentry.init({
        dsn: window.INIT_DATA.SENTRY_DSN,
        environment: window.INIT_DATA.ENVIRONMENT,
        release: window.INIT_DATA.RELEASE && `batch-upload-clients@${window.INIT_DATA.RELEASE}`,
    });
    if (window.INIT_DATA.USER_EMAIL) {
        Sentry.configureScope((scope) => {
            scope.setUser({ email: window.INIT_DATA.USER_EMAIL });
        });
    }
}

ReactDOM.render(
    <MemoryRouter>
        <Switch>
            <Route exact path="/" component={IntroPage} />
            <Route path="/upload" component={UploadPage} />
        </Switch>
    </MemoryRouter>,
    document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
